import apiClient from './client';

/**
 * Phase 18.3 — AI-assist for paid post teasers.
 * Backend uses Emergent universal LLM key (Claude Sonnet 4.6) — no per-call
 * credentials needed from the frontend.
 */
export const generateTeaser = async ({ caption = '', media_type = 'image', price = 0 }) => {
  const res = await apiClient.post('/ai/teaser', { caption, media_type, price });
  return res.data; // { teaser }
};
